import type { TmWrappers } from '@/wrappers'
import type { StatusColor } from '@/components/shared/types'
import type { PaginationUrlFilterType } from '@/services/tables/types'

export const listModalId: TmWrappers = 'contactList'
export const contactListMoveCopyModalId: TmWrappers = 'contactListMoveCopyModal'

export const allContactListModal: TmWrappers = 'allContactListModal'

export enum ContactListActions {
  Move = 'move',
  Copy = 'copy',
}

export type ListPostBody = {
  id?: string
  name: string
  shared: boolean
  isDefault: boolean
  folderId?: number
}

// `ids`, `all` and `filters` are mutually exclusive on the backend — pick exactly one.
export type AssignContactsToListPutBody =
  | {
      ids: string[]
      all: boolean
      from?: string
      isCopyAction?: boolean
      filters?: never
      searchQuery?: never
    }
  | {
      filters: PaginationUrlFilterType
      searchQuery: string
      isCopyAction?: boolean
      ids?: never
      all?: never
      from?: never
    }

export type CreateContactListResponseBody = {
  status: 201
  data: {
    id: number
  }
}
export type ToggleContactListVisibilityType = {
  contactListIds: string[]
  visible: boolean
  all: boolean
}

export type ContactListServiceSharingStatusType = 'Private' | 'SharedByMe' | 'SharedToMe'

export type ContactListServiceSharingStatus = {
  status: ContactListServiceSharingStatusType
  value: string
  color: StatusColor
  tooltip: string
}

export interface ContactListFormScheme {
  name: string
  isPrivate: boolean
  isDefault: boolean
}
